import styled from '@emotion/styled';
import {
	EmailInput,
	PasswordInput,
	useAxios,
	useBrandDetails,
} from 'dw-au-react-components';
import React, { useContext, useEffect, useState } from 'react';
import { Loader } from '../../Loader';
import useForm from 'react-hook-form';
import { UserContext } from '../../../Context/User';
import CartHeader from '../../ShoppingCart/CartHeader';
import Modal from '../../Modal/Modal';

const StyledLoginForm = styled.form`
	width: 100%;
	.login-error {
		color: #ee0033;
	}
	a {
		text-decoration: underline;
	}
	.form-row {
		margin-bottom: 20px;
	}
`;

function LoginForm({ setStep, defaultValues, setGuestShipping }) {
	const { userData, fetchUserData } = useContext(UserContext);
	const [loginData, setLoginData] = useState(false);
	const [triggerLogin, setTriggerLogin] = useState(false);
	const [triggerLogOut, setTriggerLogOut] = useState(false);
	const { register, errors, handleSubmit, setValue } = useForm({
		defaultValues,
	});

	const browserUrl = location.href;

	const brandData = useBrandDetails();
	const getEnv = () => {
		if (location.host.indexOf('uat.') > -1) {
			return 'uat';
		}
		if (location.host.indexOf('st.') > -1) {
			return 'st';
		}
		if (
			location.host.indexOf('localhost') > -1 ||
			location.host.indexOf('webdev00') > -1 ||
			location.host.indexOf('rebrand.') > -1
		) {
			return 'webdev';
		} else {
			return 'live';
		}
	};

	const getForgotPasswordURL = () => {
		const env = getEnv();
		const brand = brandData.tag;

		if (env === 'uat') {
			if (brand === 'wpe') {
				return 'https://uat.auth.laithwaites.com.au/auwp/authn/authentication/auwp-username-password-authenticator/forgot-password';
			}

			if (brand === 'adc') {
				return 'https://uat.auth.theaustralianwine.com.au/auadc/authn/authentication/auadc-username-password-authenticator/forgot-password';
			}

			if (brand === 'law') {
				return 'https://uat.auth.laithwaites.co.nz/nzlw/authn/authentication/nzlw-username-password-authenticator/forgot-password';
			}

			if (brand === 'vir') {
				return 'https://uat.auth.virginwines.com.au/auvirgin/authn/authentication/auvirgin-username-password-authenticator/forgot-password';
			}
		}

		if (env === 'st') {
			if (brand === 'wpe') {
				return 'https://sit.auth.laithwaites.com.au/auwp/authn/authentication/auwp-username-password-authenticator/forgot-password';
			}

			if (brand === 'adc') {
				return 'https://sit.auth.theaustralianwine.com.au/auadc/authn/authentication/auadc-username-password-authenticator/forgot-password';
			}

			if (brand === 'law') {
				return 'https://sit.auth.laithwaites.co.nz/nzlw/authn/authentication/nzlw-username-password-authenticator/forgot-password';
			}

			if (brand === 'vir') {
				return 'https://sit.auth.virginwines.com.au/auvirgin/authn/authentication/auvirgin-username-password-authenticator/forgot-password';
			}
		}

		if (env === 'live') {
			if (brand === 'wpe') {
				return 'https://auth.laithwaites.com.au/auwp/authn/authentication/auwp-username-password-authenticator/forgot-password';
			}

			if (brand === 'adc') {
				return 'https://auth.theaustralianwine.com.au/auadc/authn/authentication/auadc-username-password-authenticator/forgot-password';
			}

			if (brand === 'law') {
				return 'https://auth.laithwaites.co.nz/nzlw/authn/authentication/nzlw-username-password-authenticator/forgot-password';
			}

			if (brand === 'vir') {
				return 'https://auth.virginwines.com.au/auvirgin/authn/authentication/auvirgin-username-password-authenticator/forgot-password';
			}
		}

		return '/jsp/registration/common/account_password.jsp';
	};

	const openWindow = () => {
		window.open('/jsp/registration/common/account_password.jsp');
	};

	const onLogin = (data) => {
		const { email, password } = data;
		setLoginData({ email, password });
		// setTriggerLogin(true);
		if (
			userData.securityStatus === 2 &&
			userData?.summaryDetails?.emailAddress !== email
		) {
			setTriggerLogOut(true);
		} else {
			setTriggerLogin(true);
		}
	};

	const loginRequestArray = [
		{
			url: '/api/authentication/login',
			method: 'post',
			data: loginData,
		},
	];

	const [
		loginResponse = finalResponse,
		loginError = error,
		loginLoading = isLoading,
	] = useAxios(loginRequestArray, triggerLogin, setTriggerLogin);

	const logOutRequestArray = [
		{
			url: '/api/authentication/logout',
			method: 'post',
		},
	];
	const [logOutResponse = finalResponse, logOutLoading = isLoading] = useAxios(
		logOutRequestArray,
		triggerLogOut,
		setTriggerLogOut
	);

	useEffect(() => {
		if (logOutResponse) {
			setTriggerLogin(true);
		}
	}, [logOutResponse]);

	useEffect(() => {
		if (loginResponse) {
			fetchUserData();
		}
	}, [loginResponse]);

	useEffect(() => {
		if (userData && userData.securityStatus >= 4) {
			setStep(5);
		} else if (userData && userData.securityStatus === 2) {
			if (userData.summaryDetails?.emailAddress && !defaultValues?.email) {
				setValue('email', userData.summaryDetails?.emailAddress);
			}
		}
	}, [userData]);

	let errorData = loginError
		? loginError?.response?.data?.errorResponse?.message
		: null;

	const [loading, setLoading] = useState(true);
	const onLoad = () => {
		setLoading(false);
	};
	const [showModal, setShowModal] = useState(false);

	const toggleModal = () => {
		setShowModal(!showModal);
	};

	return (
		<>
			{defaultValues?.email && <CartHeader title='Checkout' />}
			{(loginLoading || logOutLoading) && <Loader extraClassName='overlay' />}
			{!defaultValues?.email && (
				<div className='mb-40 mt-40'>
					<h6 className='mb-16 text-center'>Login to your account</h6>
					<div
						className='text-dark-medium text-center'
						onClick={() => setStep(2)}
					>
						Or{' '}
						<span className='cursor-pointer'>
							Don’t have an account with Laithwaites? <br />
							Checkout as a new user.
						</span>
						.
					</div>
				</div>
			)}
			{defaultValues?.email && (
				<>
					<div className='subtitle roboto lower mb-12'>
						Welcome back. Enter your password below for a faster checkout.
					</div>
					<div className='mb-12'>
						We found an existing account for{' '}
						<strong className='d-inline-block'>{defaultValues?.email}</strong>.
					</div>
					<div className='mb-40'>
						<span
							className='d-inline-block cursor-pointer'
							onClick={() => {
								setGuestShipping(false);
								setStep(2);
							}}
						>
							Not you? <u>Use another account</u>
						</span>
					</div>
				</>
			)}
			{loginError ? (
				<div className='alert alert-danger mb-30'>
					{loginError
						? errorData
						: 'The email address or password you entered is incorrect. Please double-check your entry and try again.'}
				</div>
			) : null}
			{loginResponse && (
				<div className='alert alert-success mb-30'>Login success!</div>
			)}
			{/* <StyledLoginForm
				className='login-form'
				onSubmit={handleSubmit(onLogin)}
				data-cy='login-form'
			>
				<div className='form-row'>
					<EmailInput register={register} errors={errors} />
				</div>
				<div className='form-row'>
					<PasswordInput register={register} errors={errors} />
				</div>
				<div className='d-flex align-items-center justify-content-center mb-25'>
					<div className='text-dark-medium'>Forgot password?</div>&nbsp;
					<a
						//href={`${getForgotPasswordURL()}`}
						onClick={() => setShowModal(true)}
						//target='_blank'
						//rel='noopener noreferrer'
						className='cursor-pointer text-dark-medium dmlp_forgot_password'
					>
						Click here
					</a>
				</div>
				<button type='submit' className='btn btn-primary dmlp__btn w-100 mb-16'>
					Sign in
				</button>
				<div
					className='btn btn-outline-secondary btn-block'
					onClick={() => {
						errorData = null;
						if (defaultValues?.email) {
							setGuestShipping(false);
							setStep(2);
						} else {
							setStep(0);
						}
					}}
				>
					Back
				</div>
			</StyledLoginForm> */}

			<a href={`/jsp/curity/signin.jsp?redirectionURL=${browserUrl}`}>
				<button className='btn btn-primary dmlp__btn w-100 mb-16'>
					Sign in
				</button>
			</a>
			<div
				className='btn btn-outline-secondary btn-block'
				onClick={() => {
					errorData = null;
					if (defaultValues?.email) {
						setGuestShipping(false);
						setStep(2);
					} else {
						setStep(0);
					}
				}}
			>
				Back
			</div>

			<Modal showModal={showModal} modalSize='600px' toggleModal={toggleModal}>
				{loading && <Loader extraClassName='overlay' />}
				<iframe
					onLoad={onLoad}
					src={`/jsp/registration/au/common/account_password_frag_v2.jsp?dmlp=true&email=${
						defaultValues?.email ? defaultValues.email : ''
					}`}
					className=''
					width='100%'
					height='300'
					frameBorder='0'
					allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
					allowFullScreen
				/>
			</Modal>
		</>
	);
}

export default LoginForm;
